import '../css/articled.css';
import '../css/wa.css';
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { IoTimeOutline, IoHeart, IoNotificationsOutline } from "react-icons/io5";
import { FaCommentAlt, FaFireAlt, FaRegNewspaper } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function Articlet() {
    const { id } = useParams(); // URL에서 id를 가져옴  

    return (
      <>
        <div className='at-main'>
        <div className='at-container'>
        <div className='at-content'>
          <div className='at-header'>
            <span className='at-category'>Energy</span>
            <h1 className='at-title'>The Future of Renewable Energy in the Power Industry</h1>
            <div className='at-meta'>
              <img src="https://via.placeholder.com/40" alt="Author" className='at-author-img' />
              <div className='at-meta-text'>
                <span className='at-author'>By John Doe</span>
                <span className='at-date'><IoTimeOutline /> May 15, 2023 · 10 min read</span>
              </div>
            </div>
          </div>
          <div className='at-body'>
            <p>The power industry is undergoing a significant transformation as renewable energy sources become increasingly prevalent. This shift towards clean energy is driven by environmental concerns, technological advancements, and changing economic factors.</p>
            <p>Solar and wind power are at the forefront of this revolution, with rapidly decreasing costs and improving efficiency. As we look to the future, integrating these renewable sources into our existing power grids presents both challenges and opportunities.</p>
          </div>
          <div className='at-actions'>
            <button className='at-like'><IoHeart /> 256</button>
            <button className='at-comment'><FaCommentAlt /> 42</button>
            <button className='at-share'><MdOutlineArrowForwardIos /> Share</button>
          </div>
        </div>
        <div className='at-sidebar'>
          <div className='at-author-info'>
            <img src="https://via.placeholder.com/80" alt="Author" className='at-author-img' />
            <h4>John Doe</h4>
            <p>Energy Expert at PowerCo</p>
            <button className='at-follow-btn'>Follow</button>
          </div>
          <div className='at-recommended'>
            <h3>More from PowerCo</h3>
            <div className='at-rec-list'>
              <div className='at-rec-item'>
                <img src="https://via.placeholder.com/60" alt="Article thumbnail" />
                <div>
                  <a href="#">The Rise of Smart Grids</a>
                  <span className='at-rec-meta'><IoTimeOutline /> 3 days ago · 5 min read</span>
                </div>
              </div>
              <div className='at-rec-item'>
                <img src="https://via.placeholder.com/60" alt="Article thumbnail" />
                <div>
                  <a href="#">Nuclear Power: Pros and Cons</a>
                  <span className='at-rec-meta'><IoTimeOutline /> 1 week ago · 8 min read</span>
                </div>
              </div>
            </div>
          </div>
          <div className='at-power-info'>
            <h3>Power Industry Updates</h3>
            <div className='at-power-stat'>
              <span>Energy Demand: 150 GW</span>
            </div>
            <div className='at-power-stat'>
              <span>Solar Capacity: 50 GW</span>
            </div>
            <div className='at-power-stat'>
              <span>Wind Capacity: 30 GW</span>
            </div>
          </div>
          <div className='at-topics'>
            <h3>Related Topics</h3>
            <div className='at-topic-list'>
              <a href="#" className='at-topic-item'>Renewable Energy</a>
              <a href="#" className='at-topic-item'>Solar Power</a>
              <a href="#" className='at-topic-item'>Wind Energy</a>
              <a href="#" className='at-topic-item'>Green Technology</a>
            </div>
          </div>
        </div>
      </div>
        </div>
      </>
    );
  }

export default Articlet;
  